export const DEFAULTWIDTH = 826;
export const DEFAULTHEIGHT = 174;
export const MINIMUMWIDTH = 420;
export const MINIMUMHEIGHT = 342;
export const SCREENSIZE = 1000;
